"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(value) {
  return !!((value === null || value === void 0 ? void 0 : value.start) && value.end);
};
//# sourceMappingURL=validInterval.js.map